"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalPermission = exports.ReviewingParentType = exports.UserAccessType = void 0;
var UserAccessType;
(function (UserAccessType) {
    UserAccessType["MEMBER"] = "member";
    UserAccessType["OWNER"] = "owner";
    UserAccessType["BOOKEEPER"] = "bookkeeper";
    UserAccessType["BOOKKEEPER_BASIC"] = "bookkeeper-basic";
    UserAccessType["BOOKKEEPER_EXTENDED"] = "bookkeeper-extended";
    UserAccessType["BOOKKEEPER_MANAGED"] = "bookkeeper-managed";
    UserAccessType["PARTNER_OWNER"] = "partner-owner";
    UserAccessType["PARTNER_MEMBER"] = "partner-member";
})(UserAccessType = exports.UserAccessType || (exports.UserAccessType = {}));
var ReviewingParentType;
(function (ReviewingParentType) {
    ReviewingParentType["COMPANY"] = "company";
    ReviewingParentType["ORGANIZATION"] = "organization";
})(ReviewingParentType = exports.ReviewingParentType || (exports.ReviewingParentType = {}));
var ExternalPermission;
(function (ExternalPermission) {
    ExternalPermission["RECLAIM_VAT"] = "reclaimVAT";
})(ExternalPermission = exports.ExternalPermission || (exports.ExternalPermission = {}));
//# sourceMappingURL=user.js.map